const customEnglishMessages = {
    'configuration': {
        general: "General",
        fabric: "Fabric",
        pdfs: "PDFs",
        shipping_method_regular: 'Shipping Method: Regular',
        shipping_method_expedited: 'Shipping Method: Expedited',
        shipping_method_own_account: 'Shipping Method: Own Account',
        shipping_method_free: 'Shipping Method: Free',
        environment: 'Environment',
        social: "Social",
        contact: "Contact",
        email: "Email",
        quantity: "Quantity",
        certificates: "Certificates",
        field: {
            name: "Name",
            description: "Description",
            shipping_method: "Shipping Method",
            searchable_attributes: "Searchable Attributes",
            suggestable_attributes: "Suggestable Attributes",
            min_qty: "Minimum Quantity",
            prod_min: "Production Minimum",
            complete_order_days: "Complete Order Days",
            session_cookie_name: "Session Cookie Name",
            sku_list: "SKU List",
            freight_chart: "Freight Chart",
            hanging_sequence: "Hanging Sequence",
            order_commitment_form: "Order Commitment Form",
            nys_resale_certificate: "NYS Resale Certificate",
            ct_resale_certificate: "CT Resale Certificate",
            presentation_cut_form: "Presentation Cut Form",
            wire_transfer_instructions: "Wire Transfer Instructions",
            freight_base_price: "Freight Base Price",
            freight_price_per_item: "Freight Price Per Item",
            title: "Title",
            front_url_title: "Front Url Title",
            front_url: "Front Url",
            admin_url: "Admin Url",
            aws_cloud_front_url: "AWS Cloud Front Url",
            facebook: "Facebook",
            instagram: "Instagram",
            linkedin: "LinkedIn",
            youtube: "YouTube",
            viber: "Viber",
            whatsapp: "WhatsApp",
            email: "Email",
            street_address: "Street Address",
            state: "State",
            phone: "Phone",
            phones: "Phones",
            week_work_hours: "Week Work Hours",
            saturday_hours: "Saturday Hours",
            company_mb: "Company MB",
            company_pib: "Company PIB",
            map: "Map",
            link: "Link",
            city: "City",
            zipcode: "Zipcode",
            admin_emails: "Admin Emails",
            images: "Images",
            image: "Image",
            logo: "Logo",
            custom_css: "Custom Css",
            custom_js: "Custom Js",
            option: {
                regular: "Regular",
                expedited: "Expedited",
                own_account: "Own Account",
                free: "Free",
                "attributes.color": "attributes.color",
                "attributes.brand": "attributes.brand",
                "attributes.size": "attributes.size",
                "attributes.sastav": "attributes.sastav",
                "attributes.standard": "attributes.standard",
                "attributes.origin_name": "attributes.origin_name",
                "attributes.materijal": "attributes.materijal",
                "attributes.ean": "attributes.ean",
                "attributes.statuses": "attributes.statuses",
                "attributes.ext_description": "attributes.ext_description",
                "children.attributes.color": "children.attributes.color",
                "children.attributes.brand": "children.attributes.brand",
                "children.attributes.size": "children.attributes.size",
                "children.attributes.sastav": "children.attributes.sastav",
                "children.attributes.standard": "children.attributes.standard",
                "children.attributes.origin_name": "children.attributes.origin_name",
                "children.attributes.materijal": "children.attributes.materijal",
                "children.attributes.ean": "children.attributes.ean",
                "children.attributes.statuses": "children.attributes.statuses",
                "children.attributes.ext_description": "children.attributes.ext_description",
                name: "name",
                legacy_id: "legacy_id",
                sku: "sku",
                description: "description",
                short_description: "short_description",
                "children.name": "children.name",
                "children.legacy_id": "children.legacy_id",
                "children.sku": "children.sku",
                "children.description": "children.description",
                "children.short_description": "children.short_description",
                "description.suggest": "description.suggest",
                "parent.description": "parent.description",
                "parent.name": "parent.name",
                "name.suggest": "name.suggest",
                "parent.description.suggest": "parent.description.suggest",
                "parent.name.suggest": "parent.name.suggest",
                "name.fulltext": "name.fulltext",
                "parent.name.fulltext": "parent.name.fulltext",
                "parent.sku": "parent.sku",
                title: "title",
                slug: "slug",
                content: "content"         
            }
        }
    },
};

export default customEnglishMessages;
